<template>
  <div class="row justify-content-center mt-2">
    <div>
      <div class="card text-center" style="max-width:450px">
        <div class="card-body pb-0">

          <div class="row">
            <div class="pl-4 col-5 text-left">
              <div class="strong text-left lead" style="text-align:left">Swap</div>
            </div>
            <div class="col-7">
              <div class="text-right text-muted small">Balance: {{ getBalance() }} <a href="#"
                                                                                      @click="halfAmount">Half</a>&nbsp;
                <a href="#" @click="fullAmount">Max</a>
              </div>
            </div>
          </div>
          <div class="card  p-4  py-1  bg-inputs mb-1">
            <div class="row">
              <div class="col-6">
                <div class="text-left">

                  <token-select :balances="balances" :tokens="tokens" :selected="fromToken"
                                @update="updateFromToken"></token-select>


                </div>
              </div>
              <div class="col-6">
                <div class="">

                  <input type="text" pattern="[0-9]*"
                         class="form-control text-right
                       text-black font-weight-semibold  lead border-0"
                         v-model="amount"
                         placeholder="Amount"
                         @input="updateAmount"
                         style="background:inherit">
                  <div class="small text-muted">

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="icons-list-item margin-auto" style="    margin-top: -20px;
    z-index: 50;
    position: relative;
    background: white;
    float: right;
    margin-right: 20px;">
            <a class="" @click="swapDir" href="#" title="Reverse swap direction"><i class="fas fa-exchange-alt"></i></a>
          </div>
          <div class="   " style="margin-top:-15px">
            <div class=" p-4  py-1">
              <div class="row">
                <div class="col-8 text-left">
                  <div class="strong text-left lead mb-1" style="text-align:left">To</div>

                  <token-select :balances="balances" :tokens="tokens" :selected="toToken"
                                @update="updateToToken"></token-select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="routesLoading" class="card-body">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
            <i class="fas fa-spinner fa-pulse"></i>
          </div>
        </div>
        <div v-if="showNoRoutes" class="alert alert-warning">
          <i class="fas fa-exclamation-triangle"></i> Sorry, no swap routes found! Try swapping to a major token, such
          as SOL, USDC or USDT.
        </div>
        <div class="mx-5 mb-2 routeOverflow" v-if="routes?.routesInfos">
          <div class="text-muted">Best swap rates <i class="fa fa-caret-down"></i></div>
          <label v-for="(route,index) in routes.routesInfos.slice(0,numRoutes)" class="w-100 my-1">
            <input type="radio" class="d-none" v-model="selectedRoute" :value="index" @change="logRoute">
            <div class="card m-0" :class="{'border-1 border-primary': selectedRoute==index}">
              <div class="p-1">
                <div class="row">
                  <div class="col-6">
                    <div class="lead font-weight-semibold">
                    <span v-for="(meta, i) in route.marketInfos">
                      <span :class="{'small':(i>0)}">
                        <span v-if="i>0"> / </span>
                        {{ meta.amm.label }}
                      </span>
                    </span>
                    </div>
                    <div class="small">
                     <span v-for="(meta, i) in route.marketInfos">
                       <span v-if="i == 0">{{ getToken(meta.inputMint).symbol }} </span>
                       > {{ getToken(meta.outputMint).symbol }}
                     </span>
                    </div>

                  </div>
                  <div class="col-6 lead ">
                    {{ route.outAmountWithSlippage / (10 ** toToken.decimals) }} <img :src="toToken.logoURI"
                                                                                      width="20"><br>
                    <small>{{ toToken.symbol }}</small>
                  </div>
                </div>


              </div>
            </div>
          </label>

          <a href="#" @click="numRoutes=9999" v-if="this.routes?.routeInfos?.length > 2">Show all
            {{ this.routes?.routesInfos.length }} routes</a>
        </div>
        <div class="m-4">
          <button href="#"
                  :disabled="canSwap"
                  @click.prevent="swap"
                  class="btn btn-lg btn-info btn-pill" v-html="swapButtonText"></button>
        </div>
      </div>
      <div class="small text-center text-muted" style="margin-top:-18px">Powered by Jupiter</div>
    </div>
  </div>
</template>

<script>
// import {getPlatformFeeAccounts, Jupiter, TOKEN_LIST_URL} from "@jup-ag/core";
import axios from "axios";

import {watchEffect, reactive, ref, unref, isProxy, toRaw} from "vue";
import { useWallet } from 'solana-wallets-vue';
import {Connection, PublicKey} from "@solana/web3.js";
import TokenSelector from "./TokenSelector";

// import debounce from "lodash/debounce"

const connection = new Connection('https://api.mainnet-beta.solana.com', {commitment:'confirmed', confirmTransactionInitialTimeout: 120000});

export default {
  name: "SwapInner",
  props: ['connected', 'connection', 'from', 'to'],
  inject: ['moshaToast'],
  components: {
    'token-select': TokenSelector
  },
  data() {
    return {
      fromAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
      toAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
      fromToken: null,
      toToken: null,
      tokens: [],
      routeMap: null,
      routes: null,
      routesLoading: false,
      jupiter: null,
      slippage: 0.015,
      isConnected: false,
      amount: 1,
      selectedRoute: null,
      balances: {},
      balance: 0,
      numRoutes: 2,
      swapInProgress: false,
      blockUpdates: false,
      showNoRoutes: false,

    }
  },
  mounted() {
    if (typeof this.from !== 'undefined') {
      this.fromAddress = this.from
    }
    if (typeof this.to !== 'undefined') {
      this.toAddress = this.to
    }
    this.getTokens()
    console.log('mountd with wallet', this.wallet, 'connected', this.wallet.connected)
    // this.$nextTick(() => {
    //   this.wallet = useWallet()
    //   console.log('wallet')
    // })
    this.getWalletBalances()

    window.setInterval(() => {
      this.getWalletBalances()
    }, 15000)
    this.getJupiter()
    window.setInterval(() => {
      // this.checkDOM()
    }, 1500)
  },
  computed: {
    wallet() {
      return reactive(useWallet())
    },
    walletAddress() {
      return this.wallet.address
    },
    walletConnected() {
      return this.wallet.connected
    },
    swapButtonText() {
      if (!this.wallet.connected) return 'Connect your wallet'
      if (!this.fromToken) return 'Choose an input token'
      if (!this.toToken) return 'Choose an output token'
      if (this.routesLoading) return 'Loading routes...\n' +
          '  <i class="fas fa-spinner fa-pulse"></i>'
      if (this.showNoRoutes) return 'No routes found'
      if (this.selectedRoute == null) return 'Choose a route'
      if (this.amount == 0) return 'Enter an amount'
      if (this.swapInProgress) return 'Swapping.. \n' +
          '  <i class="fas fa-spinner fa-pulse"></i>'
      if (this.amount > this.getBalance()) return 'Insufficient ' + this.fromToken.symbol + ' balance'
      return 'Swap Now'
    },
    canSwap() {
      if (!this.wallet.connected) return true
      // if balance is insufficient, return truer

      // if fromToken is not selected, return true
      if (!this.fromToken) return true
      // if toToken is not selected, return true
      if (!this.toToken) return true
      if ((this.selectedRoute == null) || (this.routes == null)) return true
      if (this.swapInProgress) return true
      if (this.showNoRoutes) return true
      if (this.amount == 0) return true
      if (this.amount > this.getBalance()) return true
      return false
    },
    globalFrom() {
      return document.getElementById('swapData') ? document.getElementById('swapData').dataset.from : '3jzdrXXKxwkBk82u2eCWASZLCKoZs1LQTg87HBEAmBJw'
      // return reactive(document.getElementById('swapFrom').getAttribute('data-symbol'))
    },
    globalTo() {
      return 0
      // return reactive(document.getElementById('swapFrom').dataset.symbol)
    }
  },
  watch: {

    walletConnected(now, prev) {
      console.log('wallet changed')
      if (this.wallet.connected) {
        this.getWalletBalances()
        this.getJupiter()
        this.clicky('/swap/wallet-connected')
      } else {
        this.balances = {}
        this.balance = 0
        this.getJupiter()
        this.clicky('/swap/wallet-disconnected')

      }

    },
    /*  globalFrom(now, prev) {
        console.log('global from changed')
        this.fromToken = this.tokens.find(token => token.symbol === now)
        this.updateFromToken()
      },
      globalTo(now, prev) {
        console.log('global to changed')
        this.toToken = this.tokens.find(token => token.symbol === now)
        this.updateToToken()
      },*/
  },

  methods: {
    /*checkDOM() {
      let el = document.getElementById('swapData')
      if(!el) return false
      if ((this.fromToken.address !== el.dataset.from) || (this.toToken.address !== el.dataset.to)) {
        this.fromToken = this.tokens.find(token => token.address === el.dataset.from)
        this.toToken = this.tokens.find(token => token.address === el.dataset.to)
        this.updateFromToken()
      }
    },*/
    async logRoute() {

      console.log(this.routes?.routesInfos[this.selectedRoute])
      console.log(await this.routes?.routesInfos[this.selectedRoute].getDepositAndFee())
      // this.logSwap(this.routes?.routesInfos[this.selectedRoute])
    },
    getBalance() {
      if (!this.fromToken) return 0
      return this.balances[this.fromToken.address] || 0
    },
    toast(msg, type) {
      this.moshaToast(msg,
          {
            type: type,
            showIcon: 'true',
            transition: 'bounce',
            position: 'top-left',
          })
    },

    async swap() {
      let route = this.routes.routesInfos[this.selectedRoute]
      // if (isProxy(route)) {
      //   route = toRaw(route)
      // }
      console.log('executing swap on', route)
      this.swapInProgress = true
      console.log(this.jupiter)
      const {execute} = await this.jupiter.exchange({routeInfo:route})
      console.log('ran exchange', execute)
      try {
        const result = await execute({wallet: this.wallet})
        console.log('ran execute', result)
        this.getWalletBalances()
        if (result.error) {
          console.log('error', result.error)
          this.toast({
                title: 'Swap Failed: ' + result.error,
                description: result.error
              },
              'danger')
        } else {
          this.toast({
                title: 'Swap Successful',
                description: result.success
              },
              'success')
          this.logSwap(route)
        }
        console.log(result)
        this.swapInProgress = false
      } catch (error) {
        console.error(error)
        this.$honeybadger.notify(error)
        this.swapInProgress = false
        this.toast({title: 'Swap Failed', description: error.message},
            'danger')
      }

    },
    clicky: function (url) {
      if (typeof clicky === 'object') {
        // eslint-disable-next-line
        clicky.log(url)
      }
    }, logSwap(route) {
      let fromAmount = route.inAmount
      let toAmount = route.outAmount
      let fromMint = route.marketInfos[0].inputMint
      let toMint = route.marketInfos[route.marketInfos.length - 1].outputMint
      // get symbols for each
      let fromToken = this.getToken(fromMint);
      let fromSymbol = fromToken.symbol
      let toToken = this.getToken(toMint)
      let toSymbol = toToken.symbol

      // get fee
      let fee = route.marketInfos[route.marketInfos.length - 1].platformFee.amount / (10 ** toToken.decimals)
      let url = '/swap/' + fromSymbol + '/' + toSymbol + '/' + (fromAmount / (10 ** fromToken.decimals)) + '/' + (toAmount / (10 ** toToken.decimals)) + '/' + fee;
      console.log(url)
      this.clicky(url);
    },

    getToken(mint) {
      if (typeof mint !== 'string') mint = new PublicKey(mint).toBase58()
      return this.tokens.find(t => t.address === mint)
    },
    getTokens() {
      console.log('url', TOKEN_LIST_URL)
      axios.get(TOKEN_LIST_URL["mainnet-beta"]).then(res => {
        this.tokens = res.data
        this.fromToken = this.tokens.find(token => token.address === this.fromAddress)
        this.toToken = this.tokens.find(token => token.address === this.toAddress)
        console.log('tokens', this.tokens)
      })
    },
    updateFromToken(token) {
      console.log('changed from token')
      this.fromToken = token
      this.fullAmount()
      this.clicky('/swap/from/'+token.symbol)

      // this.getRoutes()
    },
    updateToToken(token) {

      this.toToken = token
      console.log('changed to token')
      this.getRoutes()
      this.clicky('/swap/to/'+token.symbol)
    },
    updateAmount() {
      console.log('changed amount')
      this.blockUpdates = false
      this.getRoutes()
      this.clicky('/swap/amount/'+this.amount)
    },
    async getRoutes() {
      if (!this.fromToken || !this.toToken) {
        console.log('missing tokens, not loading routes', this.fromToken, this.toToken)
        return false
      }
      if (this.blockUpdates) return
      if (this.jupiter === null) {
        console.log('missing jupiter, not loading routes')
        return false
      }
      this.showNoRoutes = false
      this.balance = this.balance[this.fromToken.address] || 0
      this.routesLoading = true;
      // convert to lamports based on number of token decimals
      const inputAmountLamports = this.fromToken ? Math.round(this.amount * 10 ** this.fromToken.decimals) : 0

      console.log('getting routes for ', this.fromToken.address, inputAmountLamports, this.toToken.address,
          new PublicKey(this.fromToken.address), new PublicKey(this.toToken.address))

      this.jupiter.computeRoutes({
          inputMint: new PublicKey(this.fromToken.address),
          outputMint: new PublicKey(this.toToken.address),
          inputAmount: inputAmountLamports,
          slippage: this.slippage,
          feeBps: 50,
          onlyDirectRoutes: false,
         filterTopNResult: 2,
      }).then((routes) => {
        this.routesLoading = false

        /* optionally filter non-fee Raydium routes: */
        routes.routesInfos = routes.routesInfos.filter((r) => {
          let r1 = r.marketInfos[0]?.amm?.label || ''
          let r2 = r.marketInfos[1]?.amm?.label || ''
          if ((r1 === 'Raydium') && (r2 === 'Raydium')) {
            return false
          }

          return true;
        })

        this.routes = routes

        this.selectedRoute = 0;
        console.log('found ' + routes.routesInfos.length + ' routes')
        if (routes.routesInfos.length == 0) this.showNoRoutes = true
        else this.showNoRoutes = false
      }).catch((e) => {
        this.routesLoading = false
        this.$honeybadger.notify(e)
        console.log('error getting routes', e)
      })

    },
    async getJupiter() {

      const platformFeeAndAccounts = {
        feeBps: 50,
        feeAccounts: await getPlatformFeeAccounts(
            connection,
            new PublicKey('swapJh6JRCTdjVqQJB82Ggxzq5JUjr3joLNRLcN9ba2') // The platform fee account owner
        ) // map of mint to token account pubkey
      }
      console.log(platformFeeAndAccounts)
      this.jupiter = await Jupiter.load({
        connection,
        cluster: "mainnet-beta",
        user: toRaw(this.wallet?.publicKey || ''), // or public key
        platformFeeAndAccounts: platformFeeAndAccounts,
        routeCacheDuration: 5000
      });
      // this.routeMap = this.jupiter.getRouteMap()
      this.getRoutes()
    },
    swapDir() {
      this.blockUpdates = true
      let from = this.fromToken
      this.fromToken = this.toToken
      this.toToken = from
      this.routes = []
      this.blockUpdates = false
      this.getRoutes()
    },
    getWalletBalances() {
      if (!this.wallet.connected) return
      // console.log('retrieving walletBalances')
      const accounts = connection.getParsedTokenAccountsByOwner(
          this.wallet?.publicKey,
          {programId: new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')}
      ).then(accounts => {
        let balances = {}
        accounts.value.forEach(account => {
          // console.log('token account',account)
          const mint = account.account.data.parsed.info.mint
          // console.log('found mint', mint)
          const token = this.getToken(mint)
          if (token) {
            // console.log(token)
            balances[mint] = account.account.data.parsed.info.tokenAmount.amount / (10 ** token.decimals)
          }

        })

// also get balance for Solana
        const solanaMint = 'So11111111111111111111111111111111111111112'
        const solanaBalance = connection.getBalance(this.wallet?.publicKey).then((bal) => {
          balances[solanaMint] = bal / (10 ** 9)
          // console.log('balance',bal)
          // console.log('found balances', balances, balances[this.fromAddress])
          this.balances = balances
          this.balance = balances[this.fromAddress] || 0
        })


      })
    },
    halfAmount() {
      this.amount = this.getBalance() / 2
      this.updateAmount()
    },
    fullAmount() {
      let amt = this.getBalance()
      if (this.fromToken.symbol === 'SOL') {
        amt = amt - 0.05
        if (amt < 0) amt = 0
      }
      this.amount = amt
      this.updateAmount()
    },
    selectRoute(route) {
      console.log(route)
    },
    dumpWallet() {
      console.log(this.wallet, this.wallet.connected, this.wallet.ready)
    }

  }
}
</script>

<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  opacity: 1;
}

body [type=number]::-webkit-inner-spin-button, body [type=number]::-webkit-outer-spin-button {
  opacity: 1;
}

body .form-control {
  color: inherit;
  font-size: 150%;
}

.bg-inputs {
  background: rgb(217, 236, 246);
  border-radius: .75rem;
}

.routeOverflow {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 243px;

  scrollbar-width: thin;
  scrollbar-color: #adacac;
}
</style>
